import React, { JSX } from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "../modals/modalStyles";
import { ButtonConfirmModals } from "../userGroups/UserTabsStyles";

interface BodyPortalVersionProps {
  onUpdate: () => void;
}

export const BodyPortalVersion = ({
  onUpdate,
}: BodyPortalVersionProps): JSX.Element => {
  const [t] = useTranslation("global");
  const classes = useStyles();

  return (
    <section>
      <div className={classes.confirmModal}>
        <div className="container-location-delete">
          <span className="general-modal-title mb-4">
            {t("AlertVersion.Detected")}
          </span>

          <div className="delete-loc-buttons-position">
            <ButtonConfirmModals
              type="submit"
              variant="contained"
              color="info"
              onClick={onUpdate}
            >
              OK
            </ButtonConfirmModals>
          </div>
        </div>
      </div>
    </section>
  );
};
